import {Button} from '@/components/ui/button/Button'
import {FC} from 'react'
import {StyledVerifyAgeModal, StyledVerifyAgeModalContent} from './styled'
import {useVerify18AgeWithGoCam} from '@/features/feed/queries/useVerify18AgeWithGoCam'
import {useTranslation} from 'react-i18next'

type VerifyAgeModalProps = {
    onClose: () => void
}

export const VerifyAgeModal: FC<VerifyAgeModalProps> = ({onClose}) => {
    const {t} = useTranslation()
    const onSuccess = (redirectUrl: string) => {
        window.open(redirectUrl, '_blank')
        onClose()
    }
    const {mutate: verifyAge} = useVerify18AgeWithGoCam(onSuccess)

    const body = {
        showDetectedAgeNumber: true,
        advancedLiveness: true as const,
        language: 'en',
        linkBack: `${window.location.origin}/age-verification/result`
    }

    return (
        <StyledVerifyAgeModal onClose={onClose} overlayVariant="blur">
            <StyledVerifyAgeModalContent>
                <h1>{t('restricted_content:verify_age_modal:title')}</h1>
                <p>{t('restricted_content:verify_age_modal:description')}</p>
                <Button
                    onClick={() => {
                        verifyAge(body)
                    }}
                >
                    {t('restricted_content:verify_age_modal:verify_now')}
                </Button>
            </StyledVerifyAgeModalContent>
        </StyledVerifyAgeModal>
    )
}
